import React, {
  Component,
  ComponentType,
  ExoticComponent,
  FC,
  NamedExoticComponent,
  ReactElement,
  useMemo,
  useState,
} from 'react';
import {Tabs, TabPanel} from 'react-tabs';

import {Sport, Team, TeamInfo, TimelineUpdate} from '../../../utils/types';

import Ad from '../../Common/Ad';
import PillTabList from '../../Common/PillTabList';
import AsyncWidgetStats from '../../Async/AsyncWidgetStats';
import AsyncWidgetLineups from '../../Async/AsyncWidgetLineups';

import './styles.scss';

interface Props {
  sport: Sport;
  teams: {
    home: TeamInfo;
    away: TeamInfo;
  };
  matchId: string;
  updates: TimelineUpdate[];
  AsyncWidgetStatsRenderer?: typeof AsyncWidgetStats;
  AsyncWidgetLineupsRenderer?: typeof AsyncWidgetLineups;
}

const PanelLineupsStats: FC<Props> = ({
  sport,
  teams,
  matchId,
  updates,
  AsyncWidgetStatsRenderer = AsyncWidgetStats,
  AsyncWidgetLineupsRenderer = AsyncWidgetLineups,
}: Props) => {
  const [selectedTab, setSelectedTab] = useState(1);

  const tabs = useMemo(
    () => [`LINEUP ${teams.home.shortName}`, 'STATS', `LINEUP ${teams.away.shortName}`],
    [teams]
  );

  return (
    <Tabs
      className="PanelLineupsStats"
      selectedIndex={selectedTab}
      onSelect={(index, prevIndex) => index !== prevIndex && setSelectedTab(index)}
    >
      {sport === Sport.SOCCER && PillTabList({tabs})}
      {sport === Sport.SOCCER && (
        <TabPanel>
          <AsyncWidgetLineups matchId={matchId} updates={updates} team={Team.HOME} />
        </TabPanel>
      )}
      <TabPanel>
        <AsyncWidgetStats matchId={matchId} teams={teams} />
      </TabPanel>
      {sport === Sport.SOCCER && (
        <TabPanel>
          <AsyncWidgetLineups matchId={matchId} updates={updates} team={Team.AWAY} />
        </TabPanel>
      )}
    </Tabs>
  );
};

export default React.memo(PanelLineupsStats);
